import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Films, AdSidebar } from "@/pages/Home";
import useLenis from "@/hooks/useLenis";
import api from "@/lib/api";

/* Inspiration — a curated collection of music videos, spoken-word performances,
   video poems and other pieces that reflect Harold's mission. Under the hood these
   are content items with type = "inspiration" but visually they render exactly like
   Films so the site retains its aesthetic. */
export default function InspirationPage() {
  useLenis();
  const [items, setItems] = useState([]);
  const [ads, setAds] = useState([]);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/content?type=inspiration&visible=true").then((r) => setItems(r.data)).catch(() => {});
    api.get("/content?type=ad&visible=true").then((r) => setAds(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-imi-bg text-imi-text min-h-screen" data-testid="inspiration-page">
      <Header />
      <main className="pt-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-imi-text/50 hover:text-imi-gold transition-colors">
            <ArrowLeft size={16} /> Back home
          </Link>
          <div className="mt-8 max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.35em] text-imi-gold mb-4">{settings?.inspiration_kicker || "Inspiration"}</p>
            <h1 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight" data-testid="inspiration-title">
              {settings?.inspiration_title || "Music, poems and spoken word."}
            </h1>
            <p className="mt-4 text-imi-text/60 text-base md:text-lg leading-relaxed">
              {settings?.inspiration_intro || "A curated collection of pieces that carry the same fire as the mission — music, poetry and spoken word from artists whose voices refuse silence."}
            </p>
          </div>
        </div>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-10 grid lg:grid-cols-[1fr_320px] gap-10">
          <div>
            {items.length > 0 ? (
              <Films items={items} settings={{ ...settings, films_kicker: "", films_title: "" }} />
            ) : (
              <div className="py-32 text-center text-imi-text/40" data-testid="inspiration-empty">
                No inspirations yet. Add one in Admin → Content → New content → Type: <span className="text-imi-gold">Inspiration</span>.
              </div>
            )}
          </div>
          {ads.length > 0 && (
            <div className="lg:sticky lg:top-28 lg:self-start">
              <AdSidebar items={ads} title="Recommended" />
            </div>
          )}
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
